import { getClientId } from '../../userSessionTracking/userSessionService';

export default function getUserId() {
  const userId = getClientId();
  return userId;
}
